require('/opt/odin/app/frontend/components/cms/render_component/index.module.scss');module.exports = "../../app/cells/components/cms/render_component/show.erb";